ready(qs('.CP-form'), () => {
  const $cp =  qs('.CP-form');
  const $current = qs($cp, '.current');
  const $span = qs($cp, '.current span')
  const $list = qs($cp, '.menu ul')
  const $items = qsa($cp, '.menu ul li');
  let themeText = qs($current, 'span').innerText;
  let theme = themeText.replace(/\s/g, '').toLowerCase();
  
  // add ! on error
  const createError = (add, target) => {
      const errorSpan = document.createElement('span');
      errorSpan.className = 'error-display'
      errorSpan.textContent = '!';
      if (!target.querySelector('.error-display')) {
          if (add) {
              target.appendChild(errorSpan)
          }
      } else {
          if (!add) {
              target.removeChild(target.querySelector('.error-display'))
          }
      }
  }

  // display list on click
  click($current, (evt) => {
      $list.classList.toggle('list--active')
  } );
  // for each item, handle click
  
  $items.forEach( el => click(el, () => {
      // update dataset
      $span.dataset.univers = el.dataset.filterunivers
      // update inner text
      $span.innerHTML = el.innerText
      // then remove the active class
      $list.classList.remove('list--active')
      theme = el.dataset.filterunivers
  }))

  click(qs($cp, 'input[type="submit"]'), e => {
      e.preventDefault()

      let validFields = 0,
      validFieldsToHave = 5;

      const $form = {
          name: {
              first: qs($cp, '#firstname'),
              last: qs($cp, '#lastname')
          },
          email: qs($cp, '#email'),
          message: qs($cp, '#message')
      } 

      let contactFields = [$form.name.first, $form.name.last, $form.message];

      const formData = new FormData();
      formData.append('contact_subject', theme)
      formData.append('contact_first_name', $form.name.first.value)
      formData.append('contact_last_name', $form.name.last.value)
      formData.append('contact_email', $form.email.value)
      formData.append('contact_message', $form.message.value)

      contactFields.forEach((field) => {
          if (field.value) {
              field.parentElement.classList.remove('has-error');
              createError(false, field.parentElement);
              validFields += 1;
          } else {
              field.parentElement.classList.add('has-error');
              createError(true, field.parentElement);
          }
      });

      // email
      if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($form.email.value)) {
          $form.email.parentElement.classList.remove('has-error');
          createError(false, $form.email.parentElement);
          validFields += 1
      } else {
          $form.email.parentElement.classList.add('has-error');
          createError(true, $form.email.parentElement);
      }
      
      // theme
      if (theme === 'touslesunivers') {
          $current.parentElement.classList.add('has-error');
          createError(true, $current.parentElement);
      } else {
          $current.parentElement.classList.remove('has-error');
          createError(false, $current.parentElement);
          validFields += 1
      }

      // send
      if (validFields === validFieldsToHave) {
          fetch('/wp-json/df-contact/v1/save/', {
              method: 'POST',
              header: new Headers(),
              body: formData
          })
          .then((response) => {
              if (response.status === 200) {
                  qs('.modal-container').classList.add('visible');
              }
          })
          .then(() => location.reload())
      }
  })
})


// WEBPACK FOOTER //
// ./src/scripts/components/Form.js